import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalController, AlertController, NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';

import { Project } from '../../models/Project';

import { AuthService } from '../../providers/auth-service/auth-service';
import { ProjectService } from '../../providers/project-service/project-service';

import { CreateProjectPage } from '../../pages/create-project/create-project.page';
import { Location } from '@angular/common';

import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.page.html',
  styleUrls: ['./onboarding.page.scss'],
  host: {
    'class': 'accent-page'
  }
})
export class OnboardingPage implements OnInit {
  
  project: Project;
  taintedProject: Project;

  loading: boolean = true;
  copySuccess: boolean = false;

  step: string = "loading";  

  loadingInvites: boolean = false;
  existingInvites: any = [];

  emailButtonLoading: boolean = false;
  emailVerified: boolean = false;
  emailVerificationInterval: any = -1;

  formErrors: any;

  sectorOptions = [
    {
      title: "Bitte auswählen",
      subtitle: "",
      value: "",
      hideInDropdown: true
    },{
      title: "Tech",
      subtitle: "",
      value: "",
    }
  ];
  

  constructor(
    private auth: AuthService,
    public modalController: ModalController,
    public alertController: AlertController,
    public projectService: ProjectService,
    private activatedRoute: ActivatedRoute,
    private navCtrl: NavController,
    private location: Location) { }

  ngOnInit() {

    this.auth.isReady().then(() => {
      if(this.auth.currentUser && this.auth.currentUser.emailVerified){
        this.emailVerified = true;
        this.loadProject().then((project) => {
          this.loading = false;
        });            
      } else {
        this.loading = false;
        this.step = "emailVerification";

        this.auth.afAuth.onAuthStateChanged((user)=>{
          if(user && user.emailVerified){
            this.emailVerified = true;
            clearInterval(this.emailVerificationInterval);
            this.emailVerificationInterval = -1;
            this.loadProject().then((project) => {

            });
          }
        });

        this.emailVerificationInterval = setInterval(async()=>{
            let currentUser = await this.auth.afAuth.currentUser;
            currentUser.reload();
            currentUser.getIdToken(true);
        },3000);


      }
    });

  }

  loadProject() {
    return new Promise(async (resolve, reject) => {
      let projectId = this.activatedRoute.snapshot.paramMap.get('projectId');
      let currentUrl = "/setup";

      if(projectId == ":projectId") projectId = null;

      this.project = this.projectService.getCurrentProject();
      this.projectService.isReady().then(() => {

        let splitName = (this.auth.currentUser.displayName ? this.auth.currentUser.displayName : " " ).split(" ");

        let firstName = splitName[0];
        let lastName = splitName[1];

        this.projectService.getLastOpenedProject().then(async (lastOpenedProject) => {
          console.log("last opened");
          if (this.project && this.project.id == projectId) { // current Project was set
            if(!this.project.contact){
              this.project.contact = {
                  firstName: firstName,
                  lastName: lastName,
                  email: this.auth.currentUser.email,
                  street: '',
                  zip: '',
                  city: '',
                  country: ''
                };
            }
            this.step = "contact";
            return resolve(this.project);
          }

          if (projectId) {
            console.log("find project", projectId);
            this.projectService.setCurrentProject(projectId).then(() => {
              this.project = this.projectService.getCurrentProject();

              if (this.project) {
                if(!this.project.contact){
                  this.project.contact = {
                      firstName: firstName,
                      lastName: lastName,
                      email: this.auth.currentUser.email,
                      street: '',
                      zip: '',
                      city: '',
                      country: ''
                    };
                }
              }

              this.loading = false;
              this.step = "contact";
              return resolve(this.project);
            });
          } else if (!projectId) {

            this.loading = true;
            
            console.log("NEW PROJECT");
            this.project = {
              name: '',
              description: '',
              icon: '',
              owner: [this.auth.currentUser.uid],
              team: [this.auth.currentUser.uid],
              contact: {
                firstName: firstName,
                lastName: lastName,
                email: this.auth.currentUser.email,
                street: '',
                zip: '',
                city: '',
                country: ''
              }
            } as Project;
            
            let invites = await this.projectService.getInvitesOfUser();
            invites = (invites.invites ? invites.invites : []);

            // clean out old invites (status needs to be pending)
            invites = invites.filter((invite)=>{
              return invite.status == "pending";
            });

            if(invites.length > 0){
              this.existingInvites = invites;
              this.step = "invites";
            } else {
              this.step = "creation";
            }

            this.loading = false;
            return resolve(this.project);
          }

        });
      });
    });
  }

  navigate(path: string, event: any) {
    if (this.projectService.currentProject?.id && path.indexOf(':projectId') != -1) {
      this.navCtrl.navigateForward(path.replace(':projectId', this.projectService.currentProject?.id), {
        animated: false
      });
    } else {
      this.navCtrl.navigateForward('/' + path, {
        animated: false
      });
    }
    if(event){
      event.stopPropagation();
      event.preventDefault();
    }
    return false;
  }

  navigateInvite(projectId: string, code: string){
    this.navCtrl.navigateForward('/invites/'+projectId+'/'+code, {
      animated: false
    });
  }

  handleEmoji(e){
    this.project.icon = e.char;
  }

  createProject(){
    this.loading = true;
    this.projectService.addProject(this.project).then((result)=>{
      this.projectService.setCurrentProject(result.id).then((done)=>{
        this.loading = false;
        this.step = "contact";
        this.location.replaceState(this.projectService.currentProject.id + '/setup');
        this.project = this.projectService.currentProject;
      });
    }).catch((error)=>{
      this.loading = false;
    });
  }

  resendEmailVerificationMail(){
    this.emailButtonLoading = true;
    this.auth.sendVerificationMail().then((result)=>{
      this.emailButtonLoading = false;
      this.alertController.create({
        header: 'E-Mail gesendet',
        message: 'Wir haben dir eine neue E-Mail zur Verifizierung deiner E-Mail-Adresse gesendet. Bitte überprüfe deinen Posteingang.',
        buttons: ['OK']
        }).then((alert)=>{
          alert.present();
        });
    }).catch((error)=>{
      this.emailButtonLoading = false;
      this.alertController.create({
        header: 'Fehler beim senden',
        message: 'Wir konnten dir leider keine E-Mail zur Verifizierung deiner E-Mail-Adresse senden. Bitte versuche es später erneut oder melde dich beim Support.',
        buttons: ['OK']
        }).then((alert)=>{
          alert.present();
        });
    });
  }

  /*
    Contact
  */
  submitContact(){
    this.formErrors = {};
    if(!this.project.contact.firstName || this.project.contact.firstName == "" || this.project.contact.firstName.length < 2){
      this.formErrors.firstName = "Please enter your first name.";
    }
    if(!this.project.contact.lastName || this.project.contact.lastName == "" || this.project.contact.lastName.length < 2){
      this.formErrors.lastName = "Please enter your last name.";
    }

    let emailPattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$");
    if(!this.project.contact.email || this.project.contact.email == "" || this.project.contact.email.length < 2){
      this.formErrors.email = "Please enter valid email address.";
    }
    if(this.project.contact.email && !emailPattern.test(this.project.contact.email)){
      this.formErrors.email = "Please enter valid email address.";
    }

    if(!this.project.contact.zip || this.project.contact.zip == "" || this.project.contact.zip.length < 2){
      this.formErrors.address = "Please enter valid address.";
    }
    if(!this.project.contact.street || this.project.contact.street == "" || this.project.contact.street.length < 2){
      this.formErrors.address = "Please enter valid address.";
    }
    if(!this.project.contact.city || this.project.contact.city == "" || this.project.contact.city.length < 2){
      this.formErrors.address = "Please enter valid address.";
    }

    if(this.formErrors.address || this.formErrors.email || this.formErrors.firstName || this.formErrors.lastName){
      return;
    }

    // submit
    this.loading = true;
    this.projectService.updateProjectById(this.project.id,this.project).then((result)=>{
      this.loading = false;
      this.step = "research";
    });

  }

  submitResearch(){
    this.loading = true;
    this.projectService.updateProjectById(this.project.id,this.project).then((result)=>{
      setTimeout(()=>{
        this.projectService.setCurrentProject(this.project.id).then((done)=>{
          this.loading = false;
          this.projectService.currentProject.isFilled = true;
          this.navigate(':projectId/dashboard', null);
        });
      },500);
    });
  }

  logout(){
    this.auth.logout();
    // @ts-ignore
    window.location.href = '/login?mode=logout';
  }

}
